module.exports = __webpack_public_path__ + "static/media/btn-prev.e108c844.svg";